const viewSwitch = document.getElementById('view-switch');
const sortSelect = document.getElementById('stra-sort');
const container = document.querySelector('.stra-home-bar__container');

viewSwitch.addEventListener('click', () => {
  document.getElementById('stra-home').classList.toggle('list');
  viewSwitch.classList.toggle('active');
});

sortSelect.querySelectorAll('a').forEach((item) => item.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();  
  const url = new URL(window.location.href);
  const currentParams = new URLSearchParams(window.location.search);

  const isCollectionPage = window.location.pathname.includes('/collections/');
  if (!isCollectionPage) {
    url.pathname = container.dataset.collectionUrl;
  }
  
  for (const [key, value] of currentParams.entries()) {
    if (key !== 'sort_by') {
      url.searchParams.set(key, value);
    }
  }
  
  // Set the new sort parameter
  url.searchParams.set('sort_by', this.dataset.sortBy);
  
  window.location.href = url.toString();
}));

// language toggle
document.getElementById('language-switch').addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const form = this.closest('localization-form').querySelector('form');
  const input = form.querySelector('input[name="locale_code"]');
  const currentLang = this.dataset.current;
  const firstLang = this.dataset.first;
  const secondLang = this.dataset.second;
  input.value = currentLang === secondLang ? firstLang : secondLang;
  form.submit();
});